import { useEffect } from 'react';

const GoogleTracking = () => {
  useEffect(() => {
    try {
      // Marketing/analytics tags only after cookie consent
      if (localStorage.getItem('cookie-consent') !== 'accepted') return;
      const settings = localStorage.getItem('google-integration-settings');
      if (!settings) return;

      const config = JSON.parse(settings);

      // Google Analytics
      if (config.google_analytics_enabled && config.google_analytics_id) {
        // Check if already loaded
        if (!window.gtag) {
          const script1 = document.createElement('script');
          script1.async = true;
          script1.src = `https://www.googletagmanager.com/gtag/js?id=${config.google_analytics_id}`;
          document.head.appendChild(script1);

          const script2 = document.createElement('script');
          script2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${config.google_analytics_id}');
          `;
          document.head.appendChild(script2);
          
          console.log('Google Analytics loaded:', config.google_analytics_id);
        }
      }

      // Google Ads
      if (config.google_ads_enabled && config.google_ads_id) {
        if (!window.gtag) {
          const script1 = document.createElement('script');
          script1.async = true;
          script1.src = `https://www.googletagmanager.com/gtag/js?id=${config.google_ads_id}`;
          document.head.appendChild(script1);

          const script2 = document.createElement('script');
          script2.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${config.google_ads_id}');
          `;
          document.head.appendChild(script2);
          
          console.log('Google Ads loaded:', config.google_ads_id);
        }
      }

      // Google Tag Manager
      if (config.google_tag_manager_id) {
        if (!document.querySelector(`script[src*="googletagmanager.com/gtm.js"]`)) {
          const script = document.createElement('script');
          script.innerHTML = `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${config.google_tag_manager_id}');
          `;
          document.head.appendChild(script);
          
          // Add noscript iframe
          const noscript = document.createElement('noscript');
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.googletagmanager.com/ns.html?id=${config.google_tag_manager_id}`;
          iframe.height = '0';
          iframe.width = '0';
          iframe.style.display = 'none';
          iframe.style.visibility = 'hidden';
          noscript.appendChild(iframe);
          document.body.insertBefore(noscript, document.body.firstChild);
          
          console.log('Google Tag Manager loaded:', config.google_tag_manager_id);
        }
      }
    } catch (error) {
      console.error('Error loading Google tracking:', error);
    }
  }, []);

  return null; // This component doesn't render anything
};

export default GoogleTracking;
